import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "365",
  height: "597",
  viewBox: "0 0 365 597",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { opacity: "0.4" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M64.5615 478.991C165.087 478.991 246.579 397.836 246.579 297.727C246.579 197.618 165.087 116.464 64.5615 116.464C-35.964 116.464 -117.456 197.618 -117.456 297.727C-117.456 397.836 -35.964 478.991 64.5615 478.991Z",
    fill: "#2F4A53"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M365 0L79.3222 0.255278C75.9974 0.255278 72.6726 0 69.3478 0V0.255278V113.344V119.215V264.468C69.3478 264.468 121.777 218.008 182.647 164.144C185.205 166.441 188.018 168.994 190.575 171.547C225.614 206.52 243.261 248.641 243.261 297.655C243.261 347.179 225.614 389.555 190.575 424.528C155.537 459.501 113.338 477.115 64.2327 477.115C14.6164 477.115 -27.8389 459.501 -62.8772 424.528C-97.9156 389.555 -115.563 347.179 -115.563 297.655C-115.563 248.641 -97.9156 206.52 -62.8772 171.547C-44.7187 153.422 -24.5141 139.893 -2.26343 131.213V6.63724C-56.9949 18.38 -105.588 45.1843 -147.532 87.0499C-205.844 145.253 -235 215.455 -235 297.91C-235 380.62 -205.844 451.077 -147.532 509.28C-89.22 567.484 -18.6317 596.586 64.2327 596.586C146.586 596.586 216.918 567.484 275.23 509.28C333.542 451.077 362.698 380.62 362.698 297.91C362.698 215.71 333.542 145.509 275.23 87.3052C274.207 86.2841 273.184 85.5182 272.161 84.4971C323.824 38.2917 365 1.27639 365 0Z",
    fill: "#395866"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}